import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PlatformService } from 'src/app/services/platform.service';

@Component({
  selector: 'app-update-available-dialog',
  templateUrl: './update-available-dialog.component.html',
  styleUrl: './update-available-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class UpdateAvailableDialogComponent {
  dialogRef = inject<MatDialogRef<UpdateAvailableDialogComponent>>(MatDialogRef);
  data = inject<{
    version: string;
  }>(MAT_DIALOG_DATA);

  private readonly platform = inject(PlatformService);
  private readonly snack_bar = inject(MatSnackBar);

  readonly is_installing = signal(false);

  close(): void {
    if (this.is_installing()) {
      return;
    }

    this.dialogRef.close(false);
  }

  async restartAndInstall(): Promise<void> {
    if (this.is_installing()) {
      return;
    }

    this.is_installing.set(true);
    this.dialogRef.disableClose = true;

    const result = await this.platform.restartAndInstallUpdate();
    if (result.success) {
      // Electron cierra la app al instalar; no hace falta cerrar el diálogo.
      return;
    }

    this.is_installing.set(false);
    this.snack_bar.open(this.getInstallErrorMessage(result.reason), 'Ok', { duration: 6000 });
  }

  private getInstallErrorMessage(reason: string | undefined): string {
    switch (reason) {
      case 'not_packaged':
        return 'La instalación de actualizaciones solo está disponible en la app empaquetada.';
      case 'update_not_available':
        return 'No se ha encontrado un paquete de actualización para descargar.';
      case 'not_electron':
        return 'Las actualizaciones solo están disponibles en la aplicación de escritorio.';
      default:
        return reason ? `No se pudo instalar la actualización: ${reason}` : 'No se pudo instalar la actualización.';
    }
  }
}
